import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';

const UsersComponent = ({ url, user, description, link }) => {
    const navigate = useNavigate();
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 640);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 640);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    return (
        <>
            {isSmallScreen ? (
                <div className="w-full h-fit flex flex-row items-center justify-center gap-8">
                    <div className="h-fit w-fit flex justify-start">
                        <div className="h-20 w-20 bg-cover bg-center" style={{ backgroundImage: `url(${url})` }}> </div>
                    </div>
                    <div className="flex flex-col flex-grow">
                        <h3 className="h-fit text-3xl text-[#505050] font-proximanova font-[700] mb-0">{user}</h3>
                        <p className="mt-2 text-medium text-[#505050] font-proximanova font-[400] mb-0">{description}</p>
                        <div className="mt-6 w-full">
                            <button className="w-fit text-xl text-[#9a016a] font-proximanova font-[700] border-b border-usersLink"
                                onClick={() => {
                                    navigate(link);
                                }}>
                                Browse Collection &gt;
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="px-2 w-full flex flex-col bg-white">
                    <div className="w-full h-fit flex justify-center border-usersDivider border-b pb-[16px]">
                        <div className="h-24 w-24 bg-cover bg-center" style={{ backgroundImage: `url(${url})` }}> </div>
                    </div>
                    <h3 className="mt-[20px] 1.5xl:mt-[40px] w-full h-[56px] 1.5xl:h-fit text-[24px]  1.5xl:text-[26px] text-[#505050] font-proximanova font-[700] mb-0">{user}</h3>

                    <p className="mt-[10px] 1.5xl:mt-[20px] w-full h-[112px] lg:h-[112px] 1.5xl:h-[140px] text-[18px] text-[#505050] font-proximanova font-[400] mb-0">{description}</p>

                    <button className="mt-[10px] 1.5xl:mt-[8px] w-fit text-left 1.5xl:text-[18px] font-proximanova font-[700] text-[#9a016a] border-b border-usersLink"
                        onClick={() => {
                            navigate(link);
                        }}>
                        Browse Collection &gt;
                    </button>
                </div>
            )}
        </>
    );
}

export default UsersComponent;